export default __webpack_public_path__ + "static/media/marketing url.bf71b260.pdf";